import WidgetEntity from '../WidgetEntity';

export default class ButtonStackWidget extends WidgetEntity {
  static make(pageId, type, sortOrder, isSmsRelated) {
    return {
      ...super.make(pageId, type, '', sortOrder, isSmsRelated),
      config: {
      },
      buttons: [],
    };
  }
}
